import { createContext, useContext, useState } from 'react';

// контекст для поставки, для того чтобы передать выбранные товары к странице с поставкой
// Создаем контекст
const DataContextDealClient = createContext(null);

// Провайдер контекста
export function DataProvider({ children }) {
  const [dataContext, setData] = useState(null);

  // Функция для установки данных
  const setContextData = (newData) => {
    setData(newData);
  };

  // Функция для очистки данных
  const clearContextData = () => {
    setData(null);
  };

  return (
    <DataContextDealClient.Provider value={{ dataContext, setContextData, clearContextData }}>
      {children}
    </DataContextDealClient.Provider>
  );
}

// Хук для использования контекста
export function useDataContextDeal() {
  return useContext(DataContextDealClient);
}